export default "__VITE_ASSET__CXJmmsEg__"